import { Component, OnInit, ViewChild } from '@angular/core';
import { ReservationsService, Reservation, ReservationData } from './reservations.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Organization } from 'src/app/shared/models/organization.model';
import { SharedService } from 'src/app/shared/shared.service';

@Component({
    selector: 'app-reservations',
    templateUrl: './reservations.component.html',
    styleUrls: ['./reservations.component.css'],
    standalone: false
})
export class ReservationsComponent implements OnInit {

  public orgId: string;
  public reservationSettings = new ReservationData();

  private _organization: Organization;

  constructor(private _reservationsService: ReservationsService, private _activatedRoute: ActivatedRoute,
    private _sharedService: SharedService, private _router: Router) { }

  ngOnInit(): void {
    const routeParams = this._activatedRoute.snapshot.params;
    if (!routeParams.orgId) {
      this._router.navigate(['/']);
    }
    this.orgId = routeParams.orgId;

    this._sharedService.getOrganization(routeParams.orgId).subscribe(requestResult => {
      this._organization = requestResult;
      this._sharedService.organizationNameSubject.next({ 'de': this._organization.name_de, 'it': this._organization.name_it });
    }, requestError => {
      console.log(requestError);
    });

    this._reservationsService.getReservationSettings(this.orgId).subscribe(result => {
      this.reservationSettings = result;
    });
    this._reservationsService.reservationSubject.subscribe(result => {
      this.reservationSettings = result;
    });
  }

  onReservationTypeChange(type: number, event?: any) {
    if (type === 0) {
      if (event.target.checked && this.reservationSettings.enableSlotReservation) {
        this._reservationsService.updateReservationValue(this.orgId, 3, null, false);
      }
      this._reservationsService.updateReservationValue(this.orgId, type, null, (event.target.checked ? true : false));
    } else {
      if (event.target.checked && this.reservationSettings.enableReservation) {
        console.log('QUI');
        this._reservationsService.updateReservationValue(this.orgId, 0, null, false);
      }
      this._reservationsService.updateReservationValue(this.orgId, type, null, (event.target.checked ? true : false));
    }

  }

}
